// 中文
module.exports = {
    language: {
        name: "语言",
        en: "English",
        cn: "中文",
    },
    response: {
        c_401: "暂无权限访问，请联系管理员",
        c_403: "禁止访问，请联系管理员",
        c_404: "网络不给力，请稍后重试",
        c_405: "身份已过期，请重新登录",
        c_4040: "找不到",
        c_500: "系统错误",
        c_502: "网络错误",
        c_503: "系统维护中",
        timeout: "请求超时<br>请稍后重试",
        network_error: "网络跑丢了<br>请检查网络",
    },
    list: {
        no_data: "暂无数据记录",
        pull_down: "下拉可以刷新",
        songkai: "松开立即刷新",
        refresh_ing: "正在刷新数据",
        pull_up: "上拉加载更多",
        loading: "数据加载中",
        no_more: "没有更多了",
    },
    toast: {
        title: "提示",
        confirm_bth_text: "确定",
        cancel_bth_text: "取消",
        close_bth_text: "取消",
    }
};
